import React from "react";
import "./Help.css";
import { Link, useNavigate } from "react-router-dom";
import Dark_Blue_Btn from "../../../common_components/common_btn/dark_blue_btn/Dark_Blue_Btn";

const Help = () => {

  const navigate = useNavigate()

  return (
    <section className="help-section ">
      <div className="container-fluid p-0">
        <div className="complete-banner">
          <div className="help-banner">
            <img
              src={
                process.env.PUBLIC_URL +
                "assets/Images/banner/helpdesk/helpdeskbg.png"
              }
              className="help-banner-img"
            />
          </div>
          <div className="container">
            <div className="overlay">
              <div className="heading">
                <h1>We're here to help</h1>
              </div>
              <div className="buttons">
                <div className="custum_btn_holder">
                  <Dark_Blue_Btn btn_name="Help Desk" onClick={() => {navigate("/help")}}/>
                  <Dark_Blue_Btn btn_name="Contact Us"  onClick={() => {navigate("/contact")}}/>

                  {/* <div className=" custum-btn">
                    <Link to="/help">
                      {" "}
                      <button
                        className="btn createAcc_btn"
                        fdprocessedid="s74iip"
                      >
                        Help Desk
                      </button>
                    </Link>
                  </div>
                  <div className="custum-btn">
                    <Link to="/contact">
                      {" "}
                      <button
                        className="btn createAcc_btn"
                        fdprocessedid="s74iip"
                      >
                        Contact Us
                      </button>
                    </Link>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Help;
